module.exports = __webpack_public_path__ + "img/beaver_remove.6d2a4d96.png";